export default window._env_ || {};